module.exports = __webpack_public_path__ + "img/8.0f715fd8.png";